<div class="bcs">
  <div class="bcs-selector__wrapper">
    <p class="bcs-selector__field-label">{{ 'vs_select_bcs' | translateKey }}</p>

    <div class="bcs-selector">
      <!-- Selector group for BCS 1-3 -->
      <div class="bcs-selector__group">
        <div class="bcs-labels" [class.disabled]="isDisabled">
          <span class="label" [class.active]="value > 0 && value <= 3">{{ getBCSTitle(1) }}</span>
        </div>
        <div class="bcs-progress-bar">
          <div class="bcs-progress-section section-1" [class.disabled]="activeSection !== 'section-1' || isDisabled">
            <div class="bcs-progress-fill" [style.width]="getFillWidth('section-1')"></div>
          </div>
        </div>
        <div class="bcs-selector__numbers">
          @for (bcs of [1, 2, 3]; track bcs) {
            <span class="bcs-selector--number">
              <a
                class="bcs-selector--number-link"
                (click)="selectBCS(bcs)"
                [id]="'bcs-select-' + bcs"
                [class.active_yellow]="bcs === value"
                [class.disabled]="bcs < minimalBCS || isDisabled"
                >{{ bcs }}</a
              >
            </span>
          }
        </div>
      </div>
      <!-- Selector group for BCS 4-5 -->
      <div class="bcs-selector__group">
        <div class="bcs-labels" [class.disabled]="isDisabled">
          <span class="label" [class.active]="value >= 4 && value <= 5">{{ getBCSTitle(4) }}</span>
        </div>
        <div class="bcs-progress-bar">
          <div class="bcs-progress-section section-2" [class.disabled]="activeSection !== 'section-2' || isDisabled">
            <div class="bcs-progress-fill" [style.width]="getFillWidth('section-2')"></div>
          </div>
        </div>
        <div class="bcs-selector__numbers">
          @for (bcs of [4, 5]; track bcs) {
            <span class="bcs-selector--number">
              <a
                class="bcs-selector--number-link"
                (click)="selectBCS(bcs)"
                [id]="'bcs-select-' + bcs"
                [class.active_green]="bcs === value"
                [class.disabled]="bcs < minimalBCS || isDisabled"
                >{{ bcs }}</a
              >
            </span>
          }
        </div>
      </div>
      <!-- Selector group for BCS 6-7 -->
      <div class="bcs-selector__group">
        <div class="bcs-labels" [class.disabled]="isDisabled">
          <span class="label" [class.active]="value >= 6 && value <= 7">{{ getBCSTitle(6) }}</span>
        </div>
        <div class="bcs-progress-bar">
          <div class="bcs-progress-section section-3" [class.disabled]="activeSection !== 'section-3' || isDisabled">
            <div class="bcs-progress-fill" [style.width]="getFillWidth('section-3')"></div>
          </div>
        </div>
        <div class="bcs-selector__numbers">
          @for (bcs of [6, 7]; track bcs) {
            <span class="bcs-selector--number">
              <a
                class="bcs-selector--number-link"
                (click)="selectBCS(bcs)"
                [id]="'bcs-select-' + bcs"
                [class.active_orange]="bcs === value"
                [class.disabled]="bcs < minimalBCS || isDisabled"
                >{{ bcs }}</a
              >
            </span>
          }
        </div>
      </div>
      <!-- Selector group for BCS 8-9 -->
      <div class="bcs-selector__group">
        <div class="bcs-labels" [class.disabled]="isDisabled">
          <span class="label" [class.active]="value >= 8">{{ getBCSTitle(8) }}</span>
        </div>
        <div class="bcs-progress-bar">
          <div class="bcs-progress-section section-4" [class.disabled]="activeSection !== 'section-4' || isDisabled">
            <div class="bcs-progress-fill" [style.width]="getFillWidth('section-4')"></div>
          </div>
        </div>
        <div class="bcs-selector__numbers">
          @for (bcs of [8, 9]; track bcs) {
            <span class="bcs-selector--number">
              <a
                class="bcs-selector--number-link"
                (click)="selectBCS(bcs)"
                [id]="'bcs-select-' + bcs"
                [class.active_red]="bcs === value"
                [class.disabled]="bcs < minimalBCS || isDisabled"
                >{{ bcs }}</a
              >
            </span>
          }
        </div>
      </div>
    </div>
  </div>

  @let bcsPdfUrl = bcsPdfUrl$ | async;
  @if (showBCSInfo) {
    <div class="bcs__image-container" [class.disabled]="isDisabled">
      <app-icon class="bcs__image-container-image" [name]="DetectMobile.isMobile() ? mediumBcsImageUrl() : largeBcsImageUrl()"></app-icon>
      <div class="bcs__description-container" [class.no-bcs]="!value">
        @if (value) {
          <p class="bcs__description-title">{{ BCS_Title }}</p>
          <ul class="bcs__description-bloc">
            @if (BCS_Text_1().length) {
              <li class="bcs__description">{{ BCS_Text_1() }}</li>
            }
            @if (BCS_Text_2().length) {
              <li class="bcs__description">{{ BCS_Text_2() }}</li>
            }
            @if (BCS_Text_3().length) {
              <li class="bcs__description">{{ BCS_Text_3() }}</li>
            }
            @if (BCS_Text_4().length) {
              <li class="bcs__description">{{ BCS_Text_4() }}</li>
            }
            @if (BCS_Text_5().length) {
              <li class="bcs__description">{{ BCS_Text_5() }}</li>
            }
          </ul>
        } @else {
          <div class="bcs-disclaimer">
            <app-icon name="alert"></app-icon>
            <p>{{ 'vs_bcs_placeholder_first disclaimer' | translateKey }}</p>
          </div>
          <p>{{ 'vs_bcs_placeholder_second disclaimer' | translateKey }}</p>
        }
        <div class="bcs-help">
          <rc-link
            data-qa="vs-weight-step-bcs-button-open-pdf"
            variant="secondary"
            size="large"
            target="_blank"
            rel="noopener"
            iconname="document-pdf"
            iconposition="left"
            [href]="bcsPdfUrl"
          >
            {{ 'action_condition-score' | translateKey }}
          </rc-link>
        </div>
      </div>
    </div>
  } @else {
    <div class="bcs-help">
      <rc-link
        data-qa="vs-weight-step-bcs-button-open-pdf"
        variant="secondary"
        size="large"
        iconname="document-pdf"
        iconposition="left"
        class="bcs-help__see-preview-bt"
        (click)="generatePDF(bcsPdfUrl)"
      >
        {{ 'open-bcs-guide' | translateKey }}
      </rc-link>
    </div>
  }
</div>
